import * as React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import * as Styled from './requestCallBackStyle';
import { graphql, useStaticQuery } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { marketoForms, marketoId } from '../../utils/marketoForms';
import { useRef, useState } from 'react';
import isExternalUrl, {
  addTrailingSlash,
  isExternalUrlhref,
} from '../../utils';

const RequestCallback = () => {
  const RequestCallbackQuery = useStaticQuery(graphql`
    query commercialLubricantsData {
      allContentfulRequestACallback(
        filter: { type: { eq: "IslandRequestACallback" } }
      ) {
        edges {
          node {
            title
            type
            text {
              raw
            }
            header
            node_locale
            branches
            options
            sys {
              type
              revision
            }
            shortText
            rawTextId {
              raw
            }
          }
        }
      }
    }
  `);

  const [showForm, setShowForm] = React.useState(true);
  const [FirstName, setFirstName] = React.useState('Enter First Name');
  const [LastName, setLastName] = React.useState('Enter Last Name');
  const [Email, setEmail] = React.useState('Enter Email Address');
  const [Phone, setPhone] = React.useState('Enter Phone Number');
  const [comment, setComment] = React.useState('');
  const [BWbranches, setBWbranches] = React.useState(
    'Select your closest branch'
  );
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const branchRef = useRef(null);
  const commentRef = useRef(null);

  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [branchError, setBranchError] = useState(false);
  const [commentError, setCommentError] = useState(false);

  const setBWbranchesData = (data) => {
    setBWbranches(data);
  };

  React.useEffect(() => {
    const script = document.createElement('script');
    document.body.appendChild(script);
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    let RequestCallback = marketoForms.REQUEST_CALLBACK;
    MktoForms2.loadForm(
      RequestCallback.url,
      marketoId,
      RequestCallback.marketoFormID,
      function (form) {
        form.setValues({
          BWbranches: BWbranches,
          Phone: Phone ? (Phone === 'Enter Phone Number' ? '' : Phone) : '',
          Email: Email
            ? Email === 'Enter Email Address'
              ? `noemail-${Phone}@parkland.ca`
              : Email
            : `noemail-${Phone}@parkland.ca`,
          FirstName: FirstName,
          LastName: LastName,
          comment: comment,
        });
        if (FirstName === 'Enter First Name' || FirstName === '') {
          firstNameRef.current.style.backgroundColor = '#FFD4D5';
          firstNameRef.current.style.color = 'red';
          setFirstNameError(true);
        }
        if (FirstName !== 'Enter First Name' && FirstName !== '') {
          firstNameRef.current.style.backgroundColor = '#d9ece8';
          firstNameRef.current.style.color = '#666';
          setFirstNameError(false);
        }
        if (LastName === 'Enter Last Name' || LastName === '') {
          lastNameRef.current.style.backgroundColor = '#FFD4D5';
          lastNameRef.current.style.color = 'red';
          setLastNameError(true);
        }
        if (LastName !== 'Enter Last Name' && LastName !== '') {
          lastNameRef.current.style.backgroundColor = '#d9ece8';
          lastNameRef.current.style.color = '#666';
          setLastNameError(false);
        }
        if (
          radioValue === 'Email' &&
          (Email === 'Enter Email Address' || Email === '')
        ) {
          emailRef.current.style.backgroundColor = '#FFD4D5';
          emailRef.current.style.color = 'red';
          setEmailError(true);
        }
        if (
          radioValue === 'Email' &&
          Email !== 'Enter Email Address' &&
          Email !== ''
        ) {
          emailRef.current.style.backgroundColor = '#d9ece8';
          emailRef.current.style.color = '#666';
          setEmailError(false);
        }
        if (
          radioValue === 'By Phone' &&
          (Phone === 'Enter Phone Number' || Phone === '')
        ) {
          phoneRef.current.style.backgroundColor = '#FFD4D5';
          phoneRef.current.style.color = 'red';
          setPhoneError(true);
        }
        if (
          radioValue === 'By Phone' &&
          Phone !== 'Enter Phone Number' &&
          Phone !== ''
        ) {
          phoneRef.current.style.backgroundColor = '#d9ece8';
          phoneRef.current.style.color = '#666';
          setPhoneError(false);
        }
        if (BWbranches === 'Select your closest branch') {
          branchRef.current.style.backgroundColor = '#FFD4D5';
          branchRef.current.style.color = 'red';
          setBranchError(true);
        }
        if (BWbranches !== 'Select your closest branch') {
          branchRef.current.style.backgroundColor = '#d9ece8';
          branchRef.current.style.color = '#666';
          setBranchError(false);
        }
        if (comment === '') {
          commentRef.current.style.backgroundColor = '#FFD4D5';
          commentRef.current.style.color = 'red';
          setCommentError(true);
        }
        if (comment !== '') {
          commentRef.current.style.backgroundColor = '#d9ece8';
          commentRef.current.style.color = '#666';
          setCommentError(false);
        }
        setTimeout(() => {
          var v = form.vals();
          form.submit();
          form.onSuccess(function (values, followUpUrl) {
            setShowForm(false);
            return false;
          });
        }, 1000);
      }
    );
  };

  const generateBranch = (item) => {
    let result = item.split('::');
    if (result.length === 1) {
      return result[0] === 'Select your closest branch' ? '' : result[0];
    } else {
      return result[1].trim();
    }
  };

  const resquestCallBack =
    RequestCallbackQuery.allContentfulRequestACallback.edges[0].node;
  const [radioValue, setRadioValue] = React.useState(resquestCallBack.options);
  const optionsMainStyle = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <Styled.SubmitText>{children}</Styled.SubmitText>
      ),
      [INLINES.HYPERLINK]: (node, children) => (
        <Styled.LinkColor
          href={
            isExternalUrlhref(node.data.uri)
              ? node.data.uri
              : addTrailingSlash(process.env.GATSBY_DOMAIN_URL + node.data.uri)
          }
          target={isExternalUrl(node.data.uri) ? '_blank' : '_self'}
        >
          {children}
        </Styled.LinkColor>
      ),
    },
    renderText: (text) =>
      text.split('\n').flatMap((text, i) => [i > 0 && <br />, text]),
  };

  return (
    <Styled.MainContainer fluid className="p-0">
      <Styled.InnerContainer>
        {!showForm ? (
          <div style={{ display: 'block' }} id="thankyou">
            <h2>{resquestCallBack.shortText}</h2>
            {documentToReactComponents(
              JSON.parse(resquestCallBack?.rawTextId?.raw),
              optionsMainStyle
            )}
          </div>
        ) : (
          <Row className="g-0">
            <Col xs={12} lg={3}>
              <Styled.LeftTitle>{resquestCallBack.header}</Styled.LeftTitle>
            </Col>

            <Styled.RightCol xs={12} lg={9}>
              <Form id="frmRequestCallback" method="post" onSubmit={onSubmit}>
                <Styled.RadioRow>
                  <Styled.RadioCol sm={6} md={6} lg={6}>
                    <Form.Group controlId="formBasicRadio">
                      <Styled.FormCheck
                        size="lg"
                        type="radio"
                        label="By Phone"
                        name="callback"
                        id="phone"
                        value="By Phone"
                        inline
                        checked={radioValue === 'By Phone'}
                        onChange={(e) => setRadioValue(e.target.value)}
                      />
                      <Styled.FormCheck
                        type="radio"
                        label="By Email"
                        name="callback"
                        id="email"
                        value="Email"
                        inline
                        onChange={(e) => setRadioValue(e.target.value)}
                      />
                    </Form.Group>
                  </Styled.RadioCol>
                </Styled.RadioRow>
                <Styled.FormRow>
                  <Col xs={6}>
                    {radioValue === 'By Phone' ? (
                      <Form.Group controlId="formBasicPhoneNumber">
                        <Styled.FormControl
                          size="lg"
                          type="text"
                          name="phoneInput"
                          // id="phoneInput"
                          ref={phoneRef}
                          placeholder="Enter Phone Number"
                          className="required"
                          value={Phone}
                          onClick={() => {
                            Phone === 'Enter Phone Number' && setPhone('');
                          }}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </Form.Group>
                    ) : (
                      <Form.Group controlId="formBasicEmail">
                        <Styled.FormControl
                          size="lg"
                          type="text"
                          name="emailInput"
                          // id="emailInput"
                          placeholder="Enter Email Address"
                          className="required"
                          value={Email}
                          ref={emailRef}
                          onClick={() => {
                            Email === 'Enter Email Address' && setEmail('');
                          }}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </Form.Group>
                    )}
                  </Col>
                  <Col xs={6}>
                    <Styled.FormSelect
                      size="lg"
                      aria-label="Select your closest branch"
                      // id="closestBranch"
                      name="closestBranch"
                      className="required"
                      value={BWbranches}
                      ref={branchRef}
                      onChange={(e) => setBWbranchesData(e.target.value)}
                    >
                      {resquestCallBack.branches.map((item, key) => {
                        return (
                          <option key={key} value={generateBranch(item)}>
                            {item}
                          </option>
                        );
                      })}
                    </Styled.FormSelect>
                  </Col>
                </Styled.FormRow>
                <Styled.FormRow>
                  <Col xs={6}>
                    <Form.Group controlId="formBasicFirstName">
                      <Styled.FormControl
                        size="lg"
                        type="text"
                        name="firstNameInput"
                        // id="firstNameInput"
                        value={FirstName}
                        ref={firstNameRef}
                        placeholder="Enter First Name"
                        className="active required"
                        onClick={() => {
                          FirstName === 'Enter First Name' && setFirstName('');
                        }}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group controlId="formBasicLastName">
                      <Styled.FormControl
                        size="lg"
                        type="text"
                        name="lastNameInput"
                        // id="lastNameInput"
                        placeholder="Enter Last Name"
                        value={LastName}
                        ref={lastNameRef}
                        onClick={() => {
                          LastName === 'Enter Last Name' && setLastName('');
                        }}
                        onChange={(e) => setLastName(e.target.value)}
                        className="active required"
                      />
                    </Form.Group>
                  </Col>
                </Styled.FormRow>
                <Styled.FormRow>
                  <Col xs={12}>
                    <Form.Group controlId="formBasicTextArea">
                      <Styled.TextFormControl
                        as="textarea"
                        // id="subject"
                        name="message"
                        placeholder="What would you like to talk about?"
                        className="required"
                        value={comment}
                        ref={commentRef}
                        onChange={(e) => setComment(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Styled.FormRow>
                <Row className="g-0">
                  <Col className="p-0">
                    {(firstNameError ||
                      lastNameError ||
                      emailError ||
                      phoneError ||
                      branchError ||
                      commentError) && (
                      <Styled.ErrorMsg>
                        Please check your data and make sure all fields are
                        filled.
                      </Styled.ErrorMsg>
                    )}
                  </Col>
                  <Col xs={'auto'} className="p-0">
                    <Row className=" justify-content-end g-0">
                      <Styled.FooterTextCol
                        xs={{ order: 2, span: 12 }}
                        sm={{ order: 1, span: 'auto' }}
                        className=" justify-content-end"
                      >
                        {documentToReactComponents(
                          JSON.parse(resquestCallBack?.text?.raw),
                          optionsMainStyle
                        )}
                      </Styled.FooterTextCol>
                      <Styled.ButtonCol
                        xs={{ order: 1, span: 12 }}
                        sm={{ order: 2, span: 'auto' }}
                        className=" justify-content-end"
                      >
                        <Styled.ButtonStyle type="submit">
                          SUBMIT
                        </Styled.ButtonStyle>
                      </Styled.ButtonCol>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Styled.RightCol>
          </Row>
        )}
      </Styled.InnerContainer>
    </Styled.MainContainer>
  );
};

export default RequestCallback;
